import {useEffect} from 'react'
// eslint-disable-next-line react-hooks/rules-of-hooks
export const effect = (deps, func) => useEffect(func, deps)
